// @todo this class needs big refactoring
/* eslint-disable*/
import { ValidationError, ValidationErrors } from 'types/error';
import { KeyValue } from 'types/keyvalue';
import { isEmailValid } from 'helpers/validators/email';

class Validator {
  regexp = {
    url: /^(https?:\/\/)?(([a-zA-Z0-9][a-zA-Z0-9-]?)+[a-zA-Z0-9]\.)+[a-zA-Z]{2,}(\/*)$/, // contains only alphabet chars and dashes, dashes can't be next to each other, can't start with dash
  };

  validators = {
    required: (val: string): ValidationError => {
      if (!val) {
        return {
          type: ValidationErrors.Required,
        };
      }
      return null;
    },

    email: (val: string): ValidationError => {
      if (!isEmailValid(val)) {
        return {
          type: ValidationErrors.InvalidEmail,
        };
      }
      return null;
    },

    url: (val: string): ValidationError => {
      if (!this.validateUrl(val.trim())) {
        return {
          type: ValidationErrors.InvalidUrl,
        };
      }
      return null;
    },

    notEmailOrUrl: (val: string): ValidationError => {
      if (this.validateUrl(val.trim()) || isEmailValid(val)) {
        return {
          type: ValidationErrors.InvalidNameValue,
        };
      }
      return null;
    },

    'min:(\\d+)': (val: string, matches): ValidationError => {
      const minLength = matches[1];
      if (val.length < minLength) {
        return {
          type: ValidationErrors.TooShort,
          minLength,
        };
      }
      return null;
    },

    'max:(\\d+)': (val: string, matches): ValidationError => {
      const maxLength = matches[1];

      if (val.length > maxLength) {
        return {
          type: ValidationErrors.TooLong,
          maxLength,
        };
      }
      return null;
    },
  };

  /* eslint-disable @typescript-eslint/camelcase */
  rules = {
    email: ['required', 'email', 'max:100'],
    new_email: ['required', 'email', 'max:100'],
    name: ['required', 'notEmailOrUrl', 'max:100'],
    password: ['required', 'min:8', 'max:255'],
    url: ['required', 'url', 'max:100'],
  };
  /* eslint-enable @typescript-eslint/camelcase */

  validateField = (ref): string => {
    const customValidator = ref.getAttribute('data-validator');
    let rules;
    if (customValidator) {
      rules = customValidator.split(',');
    } else {
      rules = this.rules[ref.getAttribute('name')] || [];
    }

    const skipLengthValidation = ref.id === 'sign-in-password-field';

    for (const i in Object.keys(rules)) {
      const rule = rules[i];
      // do not validate password length in sign in form
      if (skipLengthValidation && (rule.includes('min:') || rule.includes('max:'))) {
        continue;
      }
      const error = rule && typeof rule === 'string' ? this.getFieldError(ref, rule) : null;
      if (error) {
        return error;
      }
    }
    return null;
  };

  validateElementOnBlur = (errors, ref): KeyValue => {
    const nameAttribute = ref.getAttribute('name');
    const validationError = this.validateField(ref);
    const err = errors;
    // do not validate empty inputs unless they already
    // have errors
    if (!err[nameAttribute] && !ref.value.trim()) {
      return err;
    }

    if (validationError) {
      err[nameAttribute] = validationError;
    } else {
      delete err[nameAttribute];
    }
    return err;
  };

  validateElementOnChange = (errors, ref): KeyValue => {
    const nameAttribute = ref.getAttribute('name');
    const val = ref.value.trim();

    // if input is empty, remove all errors
    if (!val) {
      delete errors[nameAttribute];
      return errors;
    }

    // if element has no errors, do nothing
    if (!errors[nameAttribute]) {
      return errors;
    }

    // drop 'required' rule error
    if (errors[nameAttribute].type === 'required') {
      delete errors[nameAttribute];
      return errors;
    }
    // temporary fix for sign-in form - skip this check for password field

    // drop 'minLength' rule error
    if (errors[nameAttribute].type === 'minLength') {
      const minLength = this.rules[nameAttribute].reduce((minLength, rule) => {
        const matches = rule.match(/min:(\d+)/);
        if (matches) {
          minLength = parseInt(matches[1], 10);
        }
        return minLength;
      }, 0);

      if (val.length >= minLength) {
        delete errors[nameAttribute];
        return errors;
      }

      return errors;
    }

    // drop 'maxLength' rule error
    if (errors[nameAttribute].type === 'maxLength') {
      const maxLength = this.rules[nameAttribute].reduce((maxLength, rule) => {
        const matches = rule.match(/max:(\d+)/);
        if (matches) {
          maxLength = parseInt(matches[1], 10);
        }
        return maxLength;
      }, 0);

      if (val.length <= maxLength) {
        delete errors[nameAttribute];
        return errors;
      }

      return errors;
    }

    return errors;
  };

  getFieldError = (ref, rule): string => {
    let val = ref.value.trim();
    if (ref.name === 'password') {
      val = ref.value;
    }
    for (const regexp in this.validators) {
      if (this.validators.hasOwnProperty(regexp)) {
        const matches = rule.match(regexp);
        if (matches) {
          return this.validators[regexp](val, matches);
        }
      }
    }
    return null;
  };

  getFormInputs = (formRef) => {
    const elements = formRef.querySelectorAll('select, input:not([type="submit"]), textarea');

    // convert NodesList to array
    return Array.prototype.slice.call(elements);
  };

  validateForm = (formRef) => {
    const elements = this.getFormInputs(formRef);
    return elements.reduce((acc, field) => {
      const error = this.validateField(field);
      if (error) {
        acc[field.getAttribute('name')] = error;
      }
      return acc;
    }, {});
  };

  hasErrors(errors): boolean {
    return Object.keys(errors).length > 0;
  }

  validateUrl = (url): boolean => {
    return this.regexp.url.test(url);
  };

  removeTrailingSlash = (url) => {
    return url.replace(/\/+$/, '');
  };
}

export default new Validator();
